import uuid from "react-uuid";
import {
  getPaneIndex,
  getCustomizedDate,
  getBrands,
  getTimeInterval,
  clearGlobalvariables,
  getPrivateConversationFilters,
  removePrivateConversationFilters,
  callNotification,
  isDeepEqual,
  removeHiddenFromSaved,
  deepCopy,
  mergeArrays,
  isSameFilterDiffTypes,
} from "../../constants";
import { setPreWidgetsData } from "../ApiCall";
import moment from "moment";
import { setOrmWidgetStatus } from "../ormWidget/OrmDataPersist";
import {
  setCloseDashboardFlag,
  setFetchTemplateData,
  setOpenNewDashboardFlag,
  setSelectedTatWidgetMonth,
  setUnPinDashboard,
} from "../ApiCall/apiCall";
import { setTicketOffset } from "../ormWidget/Orm";
import {
  setActiveSectionKey,
  setFilterObject,
  setTemplateFiltersObj,
} from "../section/section";
import { getDeepDive, setUpdateImpression } from "../WidgetMaker/WidgetAPI";
import {
  setDeepDiveFlag,
  setDeepDiveInfoLoader,
  setDeepDiveWidgetLoaders,
  setIsDetailedInsightVisible,
} from "../DeepDive";
import { setOptionHighChart } from "../HighChart";
import {
  setChannelImage,
  setDashboardBrandObj,
  setProfileImage,
  setSelectProfileId,
} from "../Template";
import {
  setChartFlag,
  setGlobalSelectedWidgetId,
  setVisitedWidgetId,
} from "./dashboard";
import {
  setFilterChange,
  setIsWidgetEdit,
  setRemoveWordsPanelFlag,
} from "../Filter";
import { setDashboardDateFilterObj } from "../DateTime";
import {
  setIsNetworkWidgetSettingEdit,
  setNetworkWidgetSettingObject,
} from "../Network";
import { updateAuthParamsTemplateId } from "../AuthParams";
import { resetDeepDiveDashboard } from "../DeepDiveDashboard/DeepDiveDashboard";
import { clearDeepDiveObjectWithOthers } from "../WidgetMaker/WidgetMaker";
export const onChange = (
  panes,
  activeKey,
  previousActiveKey,
  authParams,
  paneObj,
  relatedDashboardFlag
) => {
  let index = getPaneIndex(panes, activeKey);
  if (previousActiveKey !== activeKey) {
    clearGlobalvariables();
    return (dispatch) => {
      if (
        ["/dashboard", "/pin-dashboard"]?.includes(
          window?.location?.pathname
        ) &&
        relatedDashboardFlag &&
        (authParams?.template_id || panes?.[index]?.template_id)
      ) {
        global.dashboard_id = panes?.[index]?.template_id;
        if (
          authParams?.template_id &&
          authParams?.template_id !== panes?.[index]?.template_id
        ) {
          // need to updated template id in authParams for ppt flow
          dispatch(
            updateAuthParamsTemplateId(authParams, {
              template_id: panes?.[index]?.template_id,
            })
          );
        }
      }
      if (
        ["/dashboard", "/pin-dashboard"]?.includes(
          window?.location?.pathname
        ) &&
        panes?.[index]?.template_id &&
        !panes?.[index]?.section &&
        !panes?.[index]?.sections
      ) {
        let paneObject = {
          ...paneObj,
          firstSection: true,
          template_list: true,
        };
        let template_obj = {
          created_date: panes?.[index]?.created_date,
          template_id: panes?.[index]?.template_id,
        };
        dispatch(
          setFetchTemplateData(
            authParams,
            panes?.[index]?.template_id,
            paneObject,
            template_obj
          )
        );
      }
      dispatch(setisDeepDive(false, panes, index));
      dispatch(setIsDeepDiveDashboard(false, index));
      dispatch(resetDeepDiveDashboard());
      dispatch(clearDeepDiveObjectWithOthers());
      dispatch(setDeepDiveFlag(false));
      dispatch({
        type: "SET_ACTIVE_KEY_ON_CHANGE",
        payload: activeKey,
      });
      if (panes[index]?.isDashboard) {
        dispatch(
          setSelectProfileId(
            panes[index]?.profileInfo
              ? panes[index]?.profileInfo?.name
              : panes[index]?.profiles && panes[index]?.profiles[0]?.name
              ? panes[index]?.profiles[0]?.name
              : null
          )
        );
        dispatch(
          setChannelImage(
            panes[index]?.profileInfo
              ? panes[index]?.profileInfo?.channelType
              : panes[index]?.profiles && panes[index]?.profiles[0]?.channel
              ? panes[index]?.profiles[0]?.channel
              : null
          )
        );
        dispatch(
          setProfileImage(
            panes[index]?.profileInfo
              ? panes[index]?.profileInfo?.profileIcon
              : panes[index]?.profiles &&
                panes[index]?.profiles[0]?.profile_icon_url
              ? panes[index]?.profiles[0]?.profile_icon_url
              : null
          )
        );
      }
      dispatch(setUpdateImpression(false));
      dispatch(setActiveSectionKey(null));

      dispatch(setOptionHighChart(null));
      dispatch(
        setIsDetailedInsightVisible({
          value: false,
          tab_id: null,
          name: "Mentions",
          key: "1",
        })
      );
      dispatch({ type: "SET_DEEP_DIVE_INFOBAR", payload: null });
      dispatch(setDeepDiveInfoLoader([]));

      if (!panes[index]?.isDashboard) {
        dispatch({ type: "SET_TEMPLATE_DATA", payload: null });
        dispatch(
          setDashboardTemplateFilters(
            panes?.[index]?.dashboard_template_filters,
            index,
            panes
          )
        );
      }
      // For close Filter Drawer or Hidden Remove Words Drawer
      dispatch(setRemoveWordsPanelFlag(false));
      dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(false));
      dispatch(setNetworkWidgetSettingObject(null));
      dispatch(setFilterChange(false));
      dispatch(
        setFilterObject({
          id: null,
          type: null,
          section_index: null,
          widget_index: null,
        })
      );
      dispatch(setTemplateFiltersObj(null));
      // ends here
      // to clear visited widget id and selected widget id for lazy loading
      dispatch(setVisitedWidgetId(null));
      dispatch(setGlobalSelectedWidgetId(null));

      // On change of dashboard tab, reset the brand and duration state,
      dispatch(setDashboardBrandObj(null));
      dispatch(setDashboardDateFilterObj(null));
    };
  }
};

export const onEdit = (
  targetKey,
  action,
  panes,
  activeKey,
  authParams,
  paneObj
) => {
  return (dispatch) => {
    if (action === "add") {
      dispatch(add(panes, activeKey));
      dispatch(setActiveSectionKey(null));
      dispatch(setUpdateImpression(false));
      dispatch({ type: "SET_TEMPLATE_DATA", payload: null });
    } else {
      dispatch(remove(targetKey, panes, activeKey, false, authParams, paneObj));
      dispatch(setActiveSectionKey(null));
      dispatch(setUpdateImpression(false));

      let index = panes.length - 2;
      if (!panes[index]?.isDashboard) {
        dispatch({ type: "SET_TEMPLATE_DATA", payload: null });
      }
    }
    // For close Filter Drawer or Hidden Remove Words Drawer
    dispatch(setRemoveWordsPanelFlag(false));
    dispatch(setIsWidgetEdit(false));
    dispatch(setIsNetworkWidgetSettingEdit(false));
    dispatch(setNetworkWidgetSettingObject(null));
    dispatch(setFilterChange(false));
    dispatch(
      setFilterObject({
        id: null,
        type: null,
        section_index: null,
        widget_index: null,
      })
    );
    dispatch(setTemplateFiltersObj(null));
    // ends here
    // to clear visited widget id and selected widget id for lazy loading
    dispatch(setVisitedWidgetId(null));
    dispatch(setGlobalSelectedWidgetId(null));
    // To Falase close Dashboard Flag
    dispatch(setCloseDashboardFlag(false));
    // To Falase Open New Dashboard Flag
    dispatch(setOpenNewDashboardFlag(false));
  };
};

export const add = (panes, currentKey) => {
  let index = getPaneIndex(panes, currentKey);
  const activeKey = uuid();
  const updatePrevPanes = [...panes];

  const newPanes = [...updatePrevPanes];
  newPanes[index].isDeepDive = false;
  newPanes[index].isDeepDiveDashboard = false;
  newPanes[index].deepdive = {
    deepdiveResponse: [],
    tabName: null,
  };
  newPanes.push({
    title: "Dashboards",
    description: null,

    duration: null,
    brands: null,
    sections: null,
    onlyWidgets: null,
    key: activeKey,
    isDashboard: false,
    isDeepDive: false,
    isDeepDiveDashboard: false,
    dashboard_template_filters: {
      filter_vals: [],
      search_text: "",
      pill: "All Dashboards",
      offset: 0,
      no_of_rows: 12,
      sort_expression: null,
      sort_order: null,
      type: "dashboard",
    },
  });
  global.panes = newPanes;
  global.TabActiveKey = currentKey ? currentKey : activeKey;
  return (dispatch) => {
    dispatch(
      setIsDetailedInsightVisible({
        value: false,
        tab_id: null,
        name: "Mentions",
        key: "1",
      })
    );
    dispatch({ type: "SET_DEEP_DIVE_INFOBAR", payload: null });
    dispatch(setDeepDiveInfoLoader([]));
    dispatch(resetDeepDiveDashboard());
    dispatch(clearDeepDiveObjectWithOthers());
    dispatch(setUpdateImpression(false));
    dispatch({
      type: "SET_PANES_ADD",
      activeKey: activeKey,
      panes: newPanes,
    });
  };
};

export const remove = (
  targetKey,
  panes,
  activeKey,
  closeAll,
  authParams,
  paneObj
) => {
  let newActiveKey = activeKey;
  let lastIndex;
  let initialState = null;

  return (dispatch) => {
    window.stop();
    targetKey === "1" && dispatch(setOrmWidgetStatus(null));
    let index = panes && targetKey && getPaneIndex(panes, targetKey);
    if (closeAll) {
      initialState = [
        {
          title: "Dashboards",
          description: null,

          key: "1",
          duration: null,
          brands: null,
          sections: null,
          onlyWidgets: null,
          isDashboard: false,
          isDeepDive: false,
          isDeepDiveDashboard: false,
          dashboard_template_filters: {
            filter_vals: [],
            search_text: "",
            pill: "All Dashboards",
            offset: 0,
            no_of_rows: 12,
            sort_expression: null,
            sort_order: null,
            type: "dashboard",
          },
        },
      ];
      global.panes = initialState;
      global.TabActiveKey = "1";

      dispatch({
        type: "SET_PANES_REMOVE",
        activeKey: "1",
        panes: initialState,
      });
      dispatch({ type: "SET_TEMPLATE_DATA", payload: null });
      dispatch(resetDeepDiveDashboard());
      dispatch(clearDeepDiveObjectWithOthers());
      // }
    } else if (panes?.length === 1) {
      initialState = [
        {
          title: "Dashboards",
          description: null,

          key: "1",
          duration: null,
          brands: null,
          sections: null,
          onlyWidgets: null,
          isDashboard: false,
          template_name: null,
          isDeepDive: false,
          isDeepDiveDashboard: false,
          dashboard_template_filters: {
            filter_vals: [],
            search_text: "",
            pill: "All Dashboards",
            offset: 0,
            no_of_rows: 12,
            sort_expression: null,
            sort_order: null,
            type: "dashboard",
          },
        },
      ];

      global.panes = initialState;
      global.TabActiveKey = "1";

      dispatch({
        type: "SET_PANES_REMOVE",
        activeKey: "1",
        panes: initialState,
      });
      dispatch(setUpdateImpression(false));
      dispatch(resetDeepDiveDashboard());
      dispatch(clearDeepDiveObjectWithOthers());
    } else {
      panes?.forEach((pane, i) => {
        if (pane?.key === targetKey) {
          lastIndex = i - 1;
        }
      });
      const newPanes = panes?.filter((pane) => pane.key !== targetKey);
      if (newPanes?.length && newActiveKey === targetKey) {
        if (lastIndex >= 0) {
          newActiveKey = newPanes[lastIndex]?.key;
        } else {
          newActiveKey = newPanes[0]?.key;
        }
      }

      global.panes = newPanes;
      global.TabActiveKey = newActiveKey;

      dispatch({
        type: "SET_PANES_REMOVE",
        activeKey: newActiveKey,
        panes: newPanes,
      });
      dispatch(setUpdateImpression(false));

      let selectedActiveyKey = global.TabActiveKey;
      // console.log("OUTER PNAES", panes, "INDEX", index);
      // Call API of previous panes
      if (
        selectedActiveyKey === panes?.[index - 1]?.key &&
        ["/dashboard", "/pin-dashboard"]?.includes(
          window?.location?.pathname
        ) &&
        index > 0 &&
        !panes?.[index - 1]?.section &&
        !panes?.[index - 1]?.sections &&
        panes?.[index - 1]?.template_id
      ) {
        let paneObject = {
          ...paneObj,
          firstSection: true,
          template_list: true,
        };

        let template_obj = {
          created_date: panes?.[index - 1]?.created_date,
          template_id: panes?.[index - 1]?.template_id,
        };
        paneObject.index = index - 1;
        paneObject.activeKey = panes?.[index - 1]?.key;
        paneObject.panes = newPanes;

        dispatch(
          setFetchTemplateData(
            authParams,
            panes?.[index - 1]?.template_id,
            paneObject,
            template_obj
          )
        );
      } else if (
        selectedActiveyKey === panes?.[index + 1]?.key &&
        ["/dashboard", "/pin-dashboard"]?.includes(
          window?.location?.pathname
        ) &&
        index === 0 &&
        !panes?.[index + 1]?.section &&
        !panes?.[index + 1]?.sections &&
        panes?.[index + 1]?.template_id
      ) {
        let paneObject = {
          ...paneObj,
          firstSection: true,
          template_list: true,
        };

        let template_obj = {
          created_date: panes?.[index + 1]?.created_date,
          template_id: panes?.[index + 1]?.template_id,
        };
        paneObject.index = index;
        paneObject.activeKey = panes?.[index + 1]?.key;
        paneObject.panes = [...newPanes];

        dispatch(
          setFetchTemplateData(
            authParams,
            panes?.[index + 1]?.template_id,
            paneObject,
            template_obj
          )
        );
      }
    }
    // if (panes[index]?.is_pinned) {
    //   dispatch(setUnPinDashboard(authParams, panes, activeKey, false, true));
    //   dispatch(setUpdateImpression(false));
    // }
    let current_index = getPaneIndex(panes, newActiveKey);
    if (panes[current_index]?.isDashboard) {
      //to reset global profile filters
      dispatch(
        setSelectProfileId(
          panes[current_index]?.profileInfo
            ? panes[current_index]?.profileInfo?.name
            : panes[current_index]?.profiles &&
              panes[current_index]?.profiles[0]?.name
            ? panes[current_index]?.profiles[0]?.name
            : null
        )
      );
      dispatch(
        setChannelImage(
          panes[current_index]?.profileInfo
            ? panes[current_index]?.profileInfo?.channelType
            : panes[current_index]?.profiles &&
              panes[current_index]?.profiles[0]?.channel
            ? panes[current_index]?.profiles[0]?.channel
            : null
        )
      );
      dispatch(
        setProfileImage(
          panes[current_index]?.profileInfo
            ? panes[current_index]?.profileInfo?.profileIcon
            : panes[current_index]?.profiles &&
              panes[current_index]?.profiles[0]?.profile_icon_url
            ? panes[current_index]?.profiles[0]?.profile_icon_url
            : null
        )
      );
    }
  };
};

export const onDashboardReset = (value, index, panes) => {
  const updatePanes = [
    {
      title: "Dashboards",
      description: null,

      key: "1",
      duration: null,
      brands: null,
      sections: null,
      onlyWidgets: null,
      isDashboard: false,
      isDeepDive: false,
      isDeepDiveDashboard: false,
      deepdive: { deepdiveResponse: [], tabName: null },
      pills: "All Dashboards",
      sortOrder: "asc",
      sortBy: "name",
      dashboard_template_filters: {
        filter_vals: [],
        search_text: "",
        pill: "All Dashboards",
        offset: 0,
        no_of_rows: 12,
        sort_expression: null,
        sort_order: null,
        type: "dashboard",
      },
    },
  ];

  return (dispatch) => {
    dispatch({
      type: "SET_DASHBOARD_RESET",
      activeKey: updatePanes[0].key,
      panes: updatePanes,
    });
    dispatch(resetDeepDiveDashboard());
    dispatch(clearDeepDiveObjectWithOthers());
    dispatch(setUpdateImpression(false));
  };
};

export const setSelectedAccount = (value, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = [...global_panes];
  if (updatePanes[index]) updatePanes[index].selected_account_list = value;

  return (dispatch) => {
    dispatch({ type: "SET_SELECTED_ACCOUNT", panes: updatePanes });
  };
};

export const setIsDashboard = (value, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = [...global_panes];
  if (updatePanes[index]) updatePanes[index].isDashboard = value;

  return (dispatch) => {
    dispatch({ type: "SET_IS_DASHBOARD", panes: updatePanes });
  };
};
export const updateDashboardPills = (value, index, panes) => {
  const updatePanes = [...panes];
  if (updatePanes[index]) updatePanes[index].pills = value;

  return (dispatch) => {
    dispatch({ type: "SET_UPDATE_DASHBOARD_PILL", panes: updatePanes });
  };
};
export const updateDashboardSectionOpen = (
  value,
  index,
  panes,
  section_index
) => {
  const updatePanes = [...panes];
  if (section_index >= 0) {
    updatePanes[index].sections[section_index].open = value;
  } else {
    updatePanes[index].section[0].open = value;
  }

  return (dispatch) => {
    dispatch({ type: "SET_UPDATE_DASHBOARD_PILL", panes: updatePanes });
  };
};
export const updateDashboardSorting = (sortByValue, value, index, panes) => {
  const updatePanes = [...panes];
  if (updatePanes[index]) {
    updatePanes[index].sortOrder = value;
    updatePanes[index].sortBy = sortByValue;
  }

  return (dispatch) => {
    dispatch({ type: "SET_UPDATE_DASHBOARD_SORTING", panes: updatePanes });
  };
};

export const setTemplateName = (value, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];

  if (updatePanes[index]) updatePanes[index].template_name = value;

  return (dispatch) => {
    dispatch({ type: "SET_TEMPLATE_NAME", panes: updatePanes });
  };
};

export const setClearTemplateData = (value, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  let panesActiveKey = uuid();

  updatePanes[index] = {
    title: "Dashboards",
    description: null,

    key: panesActiveKey,
    duration: null,
    brands: null,
    sections: null,
    onlyWidgets: null,
    isDashboard: false,
    isDeepDive: false,
    isDeepDiveDashboard: false,
    deepdive: { deepdiveResponse: [], tabName: null },
    pills: "All Dashboards",
    sortOrder: "asc",
    sortBy: "name",
    dashboard_template_filters: {
      filter_vals: [],
      search_text: "",
      pill: "All Dashboards",
      offset: 0,
      no_of_rows: 12,
      sort_expression: null,
      sort_order: null,
      type: "dashboard",
    },
  };

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({
      type: "SET_CLEAR_TEMPLATE_DATA",
      activeKey: panesActiveKey,
      panes: updatePanes,
    });
    dispatch(resetDeepDiveDashboard());
    dispatch(clearDeepDiveObjectWithOthers());
  };
};

export const setTemplateInPane = (template, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = [...global_panes];

  if (!template?.hidden_filter && updatePanes?.[index]?.hidden_filter) {
    updatePanes[index].hidden_filter = null;
  }
  if (!template?.quick_filter && updatePanes?.[index]?.quick_filter_value) {
    updatePanes[index].quick_filter_value = null;
  }
  if (["custom", "benchmarking"]?.includes(template?.template_type)) {
    if (
      updatePanes?.[index].private_conversation === false ||
      updatePanes?.[index].private_conversation
    ) {
      delete updatePanes?.[index].private_conversation;
    }
    if (
      updatePanes?.[index].public_engagement_only === false ||
      updatePanes?.[index].public_engagement_only
    ) {
      delete updatePanes?.[index].public_engagement_only;
    }
  } else if (template?.template_type === "competition") {
    if (
      template?.template_type === "competition" &&
      updatePanes?.[index].public_engagement_only !== false &&
      updatePanes?.[index].public_engagement_only !== true
    ) {
      template.public_engagement_only = true;
    }
    if (
      template?.template_type === "competition" &&
      updatePanes?.[index].private_conversation !== false &&
      updatePanes?.[index].private_conversation !== true
    ) {
      template.private_conversation = false;
      // template.filters = removePrivateConversationFilters(
      //   template.comp_hidden_filter,
      //   template.filters
      // );
      template.filters = getPrivateConversationFilters(
        template.comp_hidden_filter,
        template.filters ? template.filters : [],
        template?.saved_filters
      );
      // callNotification(
      //   "Filters updated by including Private conversations",
      //   "info"
      // );
    } else if (
      template?.template_type === "competition" &&
      updatePanes?.[index].private_conversation === false
    ) {
      template.filters = getPrivateConversationFilters(
        template.comp_hidden_filter,
        template.filters ? template.filters : [],
        template?.saved_filters
      );
      // callNotification(
      //   "Filters updated by excluding Private conversations",
      //   "info"
      // );
    }
  }

  updatePanes[index] = template && { ...global_panes[index], ...template };
  global.panes = updatePanes;

  return (dispatch) => {
    dispatch({ type: "SET_TEMPLATE_IN_PANE", panes: updatePanes });
  };
};

export const setProfileInfoPane = (
  profileInfo,
  index,
  panes,
  qucikFilterValue
) => {
  const updatePanes = [...panes];
  if (updatePanes[index]) {
    updatePanes[index].profileInfo = profileInfo;
    updatePanes[index].quick_filter_value = qucikFilterValue;
  }

  return (dispatch) => {
    dispatch({ type: "SET_TEMPLATE_IN_PANE", panes: updatePanes });
  };
};
export const setIsActiveAdCampaignStatusInPane = (
  status = false,
  paneIndex = null
) => {
  return (dispatch) => {
    dispatch({
      type: "SET_IS_ACTIVE_AD_CAMPAIGN_STATUS_IN_PANE",
      status: status,
      paneIndex: paneIndex,
    });
  };
};
export const setAdssetListInPane = (adssetList = [], paneIndex = null) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADSSET_LIST_IN_PANE",
      adssetList: adssetList,
      paneIndex: paneIndex,
    });
  };
};
export const setAdssetValueInPane = (adssetValue = null, paneIndex = null) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADSSET_VALUE_IN_PANE",
      adssetValue: adssetValue,
      paneIndex: paneIndex,
    });
  };
};
export const setAdsListInPane = (adsList = [], paneIndex = null) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADS_LIST_IN_PANE",
      adsList: adsList,
      paneIndex: paneIndex,
    });
  };
};
export const setAdsValueInPane = (adsValue = null, paneIndex = null) => {
  return (dispatch) => {
    dispatch({
      type: "SET_ADS_VALUE_IN_PANE",
      adsValue: adsValue,
      paneIndex: paneIndex,
    });
  };
};
export const setDashboardFilters = (value, index, panes) => {
  const updatePanes = [...panes];

  if (updatePanes[index]) updatePanes[index].filters = value;

  return (dispatch) => {
    dispatch({ type: "SET_DASHBOARD_FILTERS", panes: updatePanes });
  };
};

export const setWidgets = (
  value,
  index,
  panes,
  sectionIndex,
  section_id,
  sectionObj,
  brands
) => {
  const updatePanes = global?.panes ? [...global.panes] : [...panes];
  if (
    (global.dashboard_id &&
      global.dashboard_id === global?.panes?.[index]?.template_id) ||
    !global.dashboard_id
  ) {
    if (
      sectionIndex !== null &&
      updatePanes?.[sectionObj?.index]?.sections?.[sectionObj?.section_index]
    ) {
      if (updatePanes[index].section) updatePanes[index].section = null;
      if (updatePanes[index]?.sections?.[sectionIndex])
        updatePanes[index].sections[sectionIndex].widgets = value;
      if (sectionIndex === 0 && updatePanes[index]?.sections?.[sectionIndex]) {
        updatePanes[index].sections[sectionIndex].open = true;
      }

      if (
        sectionObj?.duration &&
        updatePanes?.[sectionObj?.index]?.sections?.[sectionObj?.section_index]
      ) {
        updatePanes[sectionObj?.index].sections[
          sectionObj?.section_index
        ].duration = sectionObj?.duration?.from ? sectionObj?.duration : null;

        updatePanes[sectionObj?.index].sections[
          sectionObj?.section_index
        ].start_date = sectionObj?.duration?.from
          ? sectionObj?.duration?.from
          : null;

        updatePanes[sectionObj?.index].sections[
          sectionObj?.section_index
        ].end_date = sectionObj?.duration?.from
          ? sectionObj?.duration?.to
          : null;

        updatePanes[sectionObj?.index].sections[
          sectionObj?.section_index
        ].dateFilters = sectionObj?.duration?.from
          ? [
              {
                attribute: "CreatedDate",
                type: "datetime",
                columns: {
                  from: sectionObj?.duration?.from,
                  to: sectionObj?.duration?.to,
                },
              },
            ]
          : null;
      }

      let finalBrand_list = sectionObj?.brand_list
        ? getBrands(
            brands,
            sectionObj?.brand_list,
            sectionObj?.singleBrands,
            sectionObj?.brand_groups
          )
        : null;
      updatePanes[sectionObj?.index].sections[
        sectionObj?.section_index
      ].filters = sectionObj?.filters;
      updatePanes[sectionObj?.index].sections[
        sectionObj?.section_index
      ].is_locked = sectionObj.is_locked;
      updatePanes[sectionObj?.index].sections[
        sectionObj?.section_index
      ].brand_list = finalBrand_list;

      updatePanes[sectionObj?.index].sections[
        sectionObj?.section_index
      ].brand_ids = sectionObj?.brand_list;
      updatePanes[sectionObj?.index].sections[
        sectionObj?.section_index
      ].brand_groups = sectionObj?.brand_groups;

      updatePanes[sectionObj?.index].sections[
        sectionObj?.section_index
      ].profile_filters_list = sectionObj?.profile_filters_list;

      updatePanes[sectionObj?.index].sections[
        sectionObj?.section_index
      ].relative_duration = sectionObj?.relative_duration || null;
    } else {
      updatePanes[index].section = [
        { section_id: section_id, widgets: value, onlyWidgets: true },
      ];
      updatePanes[index].sections = null;
    }
    global.panes = updatePanes;
  }

  return (dispatch) => {
    //edit dashboard to view dashboard issue
    if (sectionIndex === null || sectionIndex === undefined) {
      //to clear opdata
      dispatch(setOptionHighChart(null));
    } else if (sectionIndex === 0 && sectionObj?.AllSection) {
      //to clear opdata
      dispatch(setOptionHighChart(null));
    }

    !global.TabActiveKey && //to handle tab close issue
      dispatch({ type: "SET_WIDGETS", panes: updatePanes });
  };
};

export const setWidgetData = (
  value,
  index,
  panes,
  sectionIndex,
  section_id,
  sectionObj,
  brands,
  needToBeUpdateSection
) => {
  const updatePanes = global?.panes ? [...global.panes] : [...panes];
  if (
    (global.dashboard_id &&
      global.dashboard_id === global?.panes?.[index]?.template_id) ||
    !global.dashboard_id
  ) {
    if (needToBeUpdateSection) {
      if (sectionIndex !== null) {
        updatePanes[index].sections = sectionObj?.panes?.[index]?.sections;
      } else {
        updatePanes[index].section = sectionObj?.panes?.[index]?.section;
      }
    } else {
      if (sectionIndex !== null) {
        updatePanes[index].sections[sectionIndex].widgets[
          sectionObj?.widget_index
        ] = value;
        if (
          updatePanes[index]?.sections[sectionIndex]?.data?.[
            sectionObj?.widget_index
          ]
        ) {
          updatePanes[index].sections[sectionIndex].data[
            sectionObj?.widget_index
          ] = value;
        }
      } else {
        updatePanes[index].section[0].widgets[sectionObj?.widget_index] = value;
        if (
          updatePanes[index]?.section?.[0]?.data?.[sectionObj?.widget_index]
        ) {
          updatePanes[index].section[0].data[sectionObj?.widget_index] = value;
        }
      }
    }
  }
  global.panes = updatePanes;
  return (dispatch) => {
    !global.TabActiveKey && //to handle tab close issue
      dispatch({ type: "SET_WIDGETS", panes: updatePanes });
  };
};
export const setWidgetGraphData = (
  value,
  index,
  panes,
  sectionIndex,
  widgetIndex,
  body,
  graphObject,
  quickFilterDropdownListInNoData = null
) => {
  const updatePanes = global?.panes ? [...global.panes] : [...panes];
  if (
    (global.dashboard_id &&
      global.dashboard_id === global?.panes?.[index]?.template_id) ||
    !global.dashboard_id
  ) {
    if (
      sectionIndex !== null &&
      !global.TabActiveKey &&
      updatePanes[index]?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
    ) {
      // To reset offset value in case of global changes
      if (
        !graphObject?.offset_flag &&
        updatePanes?.[index]?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
          ?.order_by
      ) {
        updatePanes[index].sections[sectionIndex].widgets[
          widgetIndex
        ].order_by.offset = 0;
      }
      if (
        graphObject?.temp_exclude_words &&
        updatePanes?.[index]?.sections?.[sectionIndex]?.widgets?.[
          widgetIndex
        ] &&
        !updatePanes?.[index]?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
          ?.temp_exclude_words
      ) {
        updatePanes[index].sections[sectionIndex].widgets[
          widgetIndex
        ].temp_exclude_words = graphObject?.temp_exclude_words;
      }
      updatePanes[index].sections[sectionIndex].widgets[widgetIndex].graphData =
        value;
      updatePanes[index].sections[sectionIndex].widgets[widgetIndex].payload =
        body;
      updatePanes[index].sections[sectionIndex].widgets[widgetIndex].insights =
        null;
      updatePanes[index].sections[sectionIndex].widgets[
        widgetIndex
      ].open = false;
      updatePanes[index].sections[sectionIndex].widgets[
        widgetIndex
      ].profile_filters = body?.profile_filters;

      updatePanes[index].sections[sectionIndex].widgets[
        widgetIndex
      ].quickFilterDropdownListInNoData =
        quickFilterDropdownListInNoData &&
        Array.isArray(quickFilterDropdownListInNoData)
          ? quickFilterDropdownListInNoData
          : null;

      if (typeof value !== "string") {
        updatePanes[index].sections[sectionIndex].widgets[
          widgetIndex
        ].graphData.id = uuid();
      }

      let check = updatePanes[index]?.sections[
        sectionIndex
      ]?.widgets?.findIndex((el) => !el?.graphData);

      if (check === -1) {
        global.TabActiveKey = null;
      }
    } else if (
      !global.TabActiveKey &&
      updatePanes[index]?.section?.[0]?.widgets?.[widgetIndex]
    ) {
      // To reset offset value in case of global changes
      if (
        !graphObject?.offset_flag &&
        updatePanes?.[index]?.section?.[0]?.widgets?.[widgetIndex]?.order_by
      ) {
        updatePanes[index].section[0].widgets[widgetIndex].order_by.offset = 0;
      }
      if (
        graphObject?.temp_exclude_words &&
        updatePanes?.[index]?.section?.[0]?.widgets?.[widgetIndex] &&
        !updatePanes?.[index]?.section?.[0]?.widgets?.[widgetIndex]
          ?.temp_exclude_words
      ) {
        updatePanes[index].section[0].widgets[widgetIndex].temp_exclude_words =
          graphObject?.temp_exclude_words;
      }
      updatePanes[index].section[0].widgets[widgetIndex].graphData = value;
      if (
        updatePanes[index].section[0].widgets[widgetIndex]?.data_source ===
          "realtime" &&
        graphObject?.graphConditionConfig &&
        updatePanes[index].template_id ===
          graphObject?.graphConditionConfig?.realtime_refresh
      ) {
        updatePanes[index].section[0].widgets[widgetIndex].persist_graphdata =
          value;
      }

      updatePanes[index].section[0].widgets[widgetIndex].payload = body;
      updatePanes[index].section[0].widgets[widgetIndex].insights = null;
      updatePanes[index].section[0].widgets[widgetIndex].open = false;
      updatePanes[index].section[0].widgets[widgetIndex].profile_filters =
        body?.profile_filters;

      updatePanes[index].section[0].widgets[
        widgetIndex
      ].quickFilterDropdownListInNoData =
        quickFilterDropdownListInNoData &&
        Array.isArray(quickFilterDropdownListInNoData)
          ? quickFilterDropdownListInNoData
          : null;

      if (typeof value !== "string")
        updatePanes[index].section[0].widgets[widgetIndex].graphData.id =
          uuid();
    }
    global.panes = updatePanes;
  }

  return (dispatch) => {
    dispatch(setChartFlag(true));
    if (!global.TabActiveKey)
      //to handle close tab issue
      dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
  };
};

export const setClearWidgetGraphData = (
  panes,
  index,
  sectionIndex,
  widgetIndex
) => {
  const updatePanes = global?.panes ? [...global.panes] : [...panes];
  if (
    sectionIndex !== null &&
    updatePanes[index]?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
  ) {
    delete updatePanes[index].sections[sectionIndex].widgets[widgetIndex]
      .graphData;
  } else if (updatePanes[index]?.section?.[0]?.widgets?.[widgetIndex]) {
    delete updatePanes[index].section[0].widgets[widgetIndex].graphData;
  }

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
  };
};
export const setDefaultSortByValueInMetaData = (
  panes,
  index,
  sectionIndex,
  widgetIndex,
  defaultValue
) => {
  const updatePanes = global?.panes ? [...global.panes] : [...panes];
  if (
    sectionIndex !== null &&
    updatePanes[index]?.sections?.[sectionIndex]?.widgets?.[widgetIndex]
  ) {
    updatePanes[index].sections[sectionIndex].widgets[
      widgetIndex
    ].defaultSortByValue = defaultValue;
  } else if (updatePanes[index]?.section?.[0]?.widgets?.[widgetIndex]) {
    updatePanes[index].section[0].widgets[widgetIndex].defaultSortByValue =
      defaultValue;
  }

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
  };
};
export const setWidgetAIGeneratedInsights = (
  insights,
  index,
  panes,
  sectionIndex,
  widgetIndex,
  prompt_text
) => {
  const updatePanes = [...panes];

  if (sectionIndex !== null) {
    updatePanes[index].sections[sectionIndex].widgets[widgetIndex].insights =
      insights;
    updatePanes[index].sections[sectionIndex].widgets[widgetIndex].open = true;
    updatePanes[index].sections[sectionIndex].widgets[widgetIndex].prompt_text =
      prompt_text ? true : false;
  } else {
    updatePanes[index].section[0].widgets[widgetIndex].insights = insights;
    updatePanes[index].section[0].widgets[widgetIndex].open = true;
    updatePanes[index].section[0].widgets[widgetIndex].prompt_text = prompt_text
      ? true
      : false;
  }

  return (dispatch) => {
    //to handle close tab issue
    dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
  };
};
export const setWidgetAIGeneratedInsightsOpenStatus = (
  open,
  index,
  panes,
  sectionIndex,
  widgetIndex,
  clear
) => {
  const updatePanes = [...panes];

  if (sectionIndex !== null) {
    updatePanes[index].sections[sectionIndex].widgets[widgetIndex].open = open;
    if (
      clear &&
      updatePanes[index].sections?.[sectionIndex]?.widgets?.[widgetIndex]
        ?.insights
    ) {
      updatePanes[index].sections[sectionIndex].widgets[widgetIndex].insights =
        null;
    }
  } else {
    updatePanes[index].section[0].widgets[widgetIndex].open = open;
    if (
      clear &&
      updatePanes?.[index]?.section?.[0]?.widgets?.[widgetIndex]?.insights
    ) {
      updatePanes[index].sections[sectionIndex].widgets[widgetIndex].insights =
        null;
    }
  }

  return (dispatch) => {
    //to handle close tab issue
    dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
  };
};
export const setPaneDuration = (paneObj, type) => {
  const updatePanes = global?.panes ? [...global?.panes] : [...paneObj?.panes];

  if (type === "global_dashboard") {
    updatePanes[paneObj?.index].duration = paneObj.duration;
    let relative_duration = paneObj?.duration?.save_as_relative
      ? {
          is_relative: paneObj?.duration?.relative?.type === "short",
          relative_type: paneObj?.duration?.relative?.value ?? null,
          // relative_days: paneObj?.duration?.days ?? null,
          relative_days: null, // For now sending null
        }
      : null;

    updatePanes[paneObj?.index].relative_duration = relative_duration;
    if (paneObj?.templateGlobalDuration)
      updatePanes[paneObj?.index].template_global_duration =
        paneObj?.templateGlobalDuration;
  }
  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_GLOBAL_DATE", panes: updatePanes });
  };
};
export const setPaneBrands = (paneObj, type) => {
  const updatePanes = [...paneObj?.panes];

  if (type === "global_dashboard") {
    updatePanes[paneObj?.index].brands =
      paneObj?.selectBrands === "clear" ? null : paneObj?.selectBrands;
    global.panes[paneObj?.index].brands = updatePanes[paneObj?.index].brands
      ? updatePanes[paneObj?.index].brands
      : null;
    if (
      paneObj?.templateGlobalBrands?.length > 0 ||
      !paneObj?.templateGlobalBrands?.length
    )
      updatePanes[paneObj?.index].template_global_brands =
        paneObj?.templateGlobalBrands;
  }

  return (dispatch) => {
    dispatch({ type: "SET_GLOBAL_BRANDS", panes: updatePanes });
  };
};

export const setPaneQuickFilter = (paneObj, value) => {
  const updatePanes = [...paneObj?.panes];
  updatePanes[paneObj?.index].quick_filter = value?.quick_filter;
  updatePanes[paneObj?.index].hidden_filter = value?.hidden_filter;
  updatePanes[paneObj?.index].template_id = value?.template_id;
  return (dispatch) => {
    dispatch({ type: "SET_QUICK_FILTER", panes: updatePanes });
  };
};

export const setClearGraphData = (index, panes, type, shareObj, share_id) => {
  let global_panes = global?.panes ? global.panes : panes;
  let updatePanes = type === "share" ? shareObj?.shareData : [...global_panes];
  let sections = shareObj?.shareData
    ? shareObj?.shareData?.sections
      ? shareObj?.shareData?.sections
      : shareObj?.shareData?.section
    : updatePanes[index]?.sections
    ? updatePanes[index]?.sections
    : updatePanes[index]?.section;
  let updated_sections = sections?.map((el, i) => {
    let arr;
    if (
      !el?.is_locked ||
      (el?.is_locked && !el?.start_date && type === "global_duration") ||
      (el?.is_locked &&
        !el?.brand_groups &&
        !el?.brand_ids &&
        type === "global_brands") ||
      (el?.is_locked && type === "global_changes") ||
      (el?.is_locked &&
        !el?.start_date &&
        shareObj?.change_type === "global_duration") ||
      (el?.is_locked && shareObj?.change_type === "global_profile") ||
      (el?.is_locked && !type)
    ) {
      arr = el?.widgets?.map((widget, j) => {
        if (
          !widget?.is_locked ||
          (widget?.is_locked &&
            !widget?.start_date &&
            type === "global_duration") ||
          (widget?.is_locked &&
            !widget?.brand_groups &&
            !widget?.brand_ids &&
            type === "global_brands") ||
          (widget?.is_locked && type === "global_changes") ||
          (widget?.is_locked &&
            !widget?.start_date &&
            shareObj?.change_type === "global_duration") ||
          (widget?.is_locked && shareObj?.change_type === "global_profile") ||
          (el?.is_locked && !type)
        ) {
          if (
            type === null &&
            widget?.data_source === "realtime" &&
            !(
              widget?.type === "rich-content" ||
              widget?.chart?.chart_type === "text"
            )
          ) {
            delete widget.graphData;
          }
          if (
            type &&
            !(
              widget?.type === "rich-content" ||
              widget?.chart?.chart_type === "text"
            )
          ) {
            if (widget?.persist_graphdata && type !== "share") {
              delete widget.persist_graphdata;
            }
            if (widget?.deep_dive_on && type !== "share") {
              delete widget.deep_dive_on;
            }
            delete widget.graphData;
            if (widget?.filter_by_dropdown) {
              widget.filter_by_dropdown = null;
            }
            if (widget?.filter_by_dropdown_data) {
              widget.filter_by_dropdown_data = null;
            }
            // Post card filter pills change
            if (widget?.filter_by) {
              widget.filter_by = null;
            }
            if (widget?.filter_by_data) {
              widget.filter_by_data = null;
            }
          }
        }
        if (type === "global_brands") {
          delete widget?.widgetSingleBrandFilter;
        }

        return widget;
      });
      el.widgets = arr?.length > 0 ? [...arr] : [];
    }

    return el;
  });

  if (shareObj?.shareData) {
    updatePanes.sections
      ? (updatePanes.sections = updated_sections)
      : (updatePanes.section = updated_sections);
  } else if (updatePanes[index]?.sections) {
    updatePanes[index].sections = updated_sections;
    global.panes = updatePanes;
  } else {
    updatePanes[index].section = updated_sections;
    global.panes = updatePanes;
  }
  return (dispatch) => {
    if (shareObj?.shareData) {
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: { ...updatePanes },
      });
    } else {
      dispatch({ type: "SET_GLOBAL_BRANDS", panes: updatePanes });
    }
  };
};
export const setClearGraphDataInShareDashboard = (type, shareObj) => {
  let updatedShareTemplateData = shareObj?.shareTemplateData
    ? { ...shareObj?.shareTemplateData }
    : null;
  let isOnlyWidgets = true;
  if (updatedShareTemplateData) {
    let sections = shareObj?.shareTemplateData?.sections
      ? shareObj?.shareTemplateData?.sections
      : shareObj?.shareTemplateData?.section;
    isOnlyWidgets = shareObj?.shareTemplateData?.sections ? false : true;
    let updated_sections = sections?.map((el, i) => {
      let arr;
      if (
        !el?.is_locked ||
        (el?.is_locked && !el?.start_date && type === "global_duration") ||
        (el?.is_locked &&
          !el?.brand_groups &&
          !el?.brand_ids &&
          type === "global_brands") ||
        (el?.is_locked &&
          !el?.brand_groups &&
          !el?.brand_ids &&
          shareObj?.change_type === "global_brands") ||
        (el?.is_locked &&
          !el?.start_date &&
          shareObj?.change_type === "global_duration") ||
        (el?.is_locked && shareObj?.change_type === "global_profile") ||
        (el?.is_locked && !type)
      ) {
        arr = el?.widgets?.map((widget, j) => {
          if (
            !widget?.is_locked ||
            (widget?.is_locked &&
              !widget?.start_date &&
              type === "global_duration") ||
            (widget?.is_locked &&
              !widget?.brand_groups &&
              !widget?.brand_ids &&
              type === "global_brands") ||
            (widget?.is_locked &&
              !widget?.start_date &&
              shareObj?.change_type === "global_duration") ||
            (widget?.is_locked && shareObj?.change_type === "global_profile") ||
            (el?.is_locked && !type)
          ) {
            if (
              type === null &&
              widget?.data_source === "realtime" &&
              !(
                widget?.type === "rich-content" ||
                widget?.chart?.chart_type === "text"
              )
            ) {
              delete widget.graphData;
            }
            if (
              type &&
              !(
                widget?.type === "rich-content" ||
                widget?.chart?.chart_type === "text"
              )
            ) {
              if (widget?.persist_graphdata && type !== "share") {
                delete widget.persist_graphdata;
              }
              if (widget?.deep_dive_on && type !== "share") {
                delete widget.deep_dive_on;
              }
              delete widget.graphData;
              if (widget?.filter_by_dropdown) {
                widget.filter_by_dropdown = null;
              }
              if (widget?.filter_by_dropdown_data) {
                widget.filter_by_dropdown_data = null;
              }
              // Post card filter pills change
              if (widget?.filter_by) {
                widget.filter_by = null;
              }
              if (widget?.filter_by_data) {
                widget.filter_by_data = null;
              }
            }
          }
          if (
            type === "global_brands" ||
            shareObj?.change_type === "global_brands"
          ) {
            delete widget?.widgetSingleBrandFilter;
          }

          return widget;
        });
        el.widgets = arr?.length > 0 ? [...arr] : [];
      }

      return el;
    });
    return (dispatch) => {
      if (shareObj?.shareTemplateData) {
        dispatch({
          type: "SET_CLEAR_GRAPH_DATA_IN_SHARE_TEMPLATE_DATA",
          isOnlyWidgets: isOnlyWidgets,
          sectionData: updated_sections,
        });
      }
    };
  }
};
export const setClearProfileFiltersPanes = (index, panes) => {
  let global_panes = global?.panes ? global.panes : panes;
  let updatePanes = [...global_panes];
  let sections = updatePanes[index]?.sections
    ? updatePanes[index]?.sections
    : updatePanes[index]?.section;
  let updated_sections = sections?.map((el, i) => {
    let arr;
    if (!el?.brand_ids && !el?.brand_groups) {
      arr = el?.widgets?.map((widget, j) => {
        if (widget?.profile_filters_flag && !widget?.is_locked) {
          widget.profile_filters = null;
        }

        return widget;
      });
      el.widgets = arr?.length > 0 ? [...arr] : [];
    }

    return el;
  });

  if (updatePanes[index]?.sections) {
    updatePanes[index].sections = updated_sections;
    global.panes = updatePanes;
  } else {
    updatePanes[index].section = updated_sections;
    global.panes = updatePanes;
  }
  return (dispatch) => {
    dispatch({ type: "SET_GLOBAL_BRANDS", panes: updatePanes });
  };
};

export const setGlobalFilter = (value, index, panes, paneObj, quickFilter) => {
  let updatePanes = global?.panes ? [...global.panes] : [...panes];
  global.TabActiveKey = null;
  return (dispatch) => {
    window.stop();
    paneObj.panes = updatePanes;
    dispatch(setDashboardCalledApiList(null, paneObj.panes, index));

    let sections = updatePanes[index]?.sections
      ? updatePanes[index]?.sections
      : updatePanes[index]?.section;

    sections &&
      sections?.forEach((el, i) => {
        if (
          updatePanes[index]?.predefined &&
          updatePanes[index]?.template_type === "ticket"
        ) {
          el?.widgets?.forEach((widget, j) => {
            if (
              (updatePanes[index]?.section && j < 5) ||
              (updatePanes[index]?.sections && j >= 0) ||
              (updatePanes[index]?.template_type === "ticket" && j >= 0)
            ) {
              let twoMonthsDuration = getCustomizedDate(6, "Days");
              let defaultDuration = {
                from:
                  moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
                  " " +
                  twoMonthsDuration?.time?.startTime,
                to:
                  moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
                  " " +
                  twoMonthsDuration?.time?.endTime,
              };

              let section_start_date = moment(
                paneObj?.panes[paneObj?.index]?.duration?.from
              )
                .startOf("month")
                .format("YYYY/MM/DD 00:00");
              let section_end_date = moment(
                paneObj?.panes[paneObj?.index]?.duration?.from
              )
                .endOf("month")
                .format("YYYY/MM/DD 23:59");
              let section_duration = {
                from: section_start_date,
                to: section_end_date,
              };
              dispatch(
                setSimpleViewDuration(
                  section_duration,
                  paneObj?.panes,
                  paneObj?.index
                )
              );
              dispatch(setSelectedTatWidgetMonth(1));

              let indexes = {
                pane_index: index,
                section_index: updatePanes[index].sections ? i : null,
                panes: panes,
                widget_index: j,
              };
              let graphObject1 = {
                authParams: paneObj?.authParams,
                start_date:
                  widget?.widget_id === "tickets_simple-view_5" ||
                  widget?.widget_id === "tickets_simple-view_6" ||
                  widget?.widget_id === "tickets_simple-view_7" ||
                  widget?.widget_id === "tickets_simple-view_8"
                    ? section_start_date
                    : paneObj?.panes[paneObj?.index]?.duration
                    ? paneObj?.panes[paneObj?.index]?.duration?.from
                    : widget?.start_date
                    ? widget?.start_date
                    : defaultDuration?.from,
                end_date:
                  widget?.widget_id === "tickets_simple-view_5" ||
                  widget?.widget_id === "tickets_simple-view_6" ||
                  widget?.widget_id === "tickets_simple-view_7" ||
                  widget?.widget_id === "tickets_simple-view_8"
                    ? section_end_date
                    : paneObj?.panes[paneObj?.index]?.duration
                    ? paneObj?.panes[paneObj?.index]?.duration?.to
                    : widget?.end_date
                    ? widget?.end_date
                    : defaultDuration?.to,
                brands: paneObj?.selectBrands
                  ? paneObj?.selectBrands?.columns
                    ? Array.isArray(paneObj?.selectBrands?.columns)
                      ? paneObj?.selectBrands?.columns
                      : [paneObj?.selectBrands?.columns]
                    : Array.isArray(paneObj?.selectBrands)
                    ? paneObj?.selectBrands
                    : [paneObj?.selectBrands]
                  : paneObj?.panes[paneObj?.index]?.brands
                  ? paneObj?.panes[paneObj?.index]?.brands?.columns
                  : paneObj?.singleBrands,
                isBrandModified: paneObj?.selectBrands
                  ? true
                  : paneObj?.panes[paneObj?.index]?.brands
                  ? true
                  : false,
                widget_id: widget?.widget_id,
                benchmark_breach:
                  widget?.widget_id === "tickets_orm_6"
                    ? 30
                    : widget?.widget_id === "tickets_orm_7"
                    ? 240
                    : widget?.widget_id === "tickets_orm_26"
                    ? 240
                    : null,
                filters: panes[index]?.filters,
                is_modified_date: paneObj?.is_modified_date,
              };
              let getInterval = getTimeInterval(
                graphObject1?.end_date,
                graphObject1?.start_date
              );
              graphObject1.chart_type =
                typeof getInterval?.defaultVal === "string"
                  ? getInterval?.defaultVal
                  : null;
              graphObject1.interval =
                widget?.widget_id === "tickets_orm_6" ||
                widget?.widget_id === "tickets_orm_7" ||
                widget?.widget_id === "tickets_orm_12" ||
                widget?.widget_id === "tickets_orm_26"
                  ? null
                  : typeof getInterval?.defaultVal === "number"
                  ? getInterval?.defaultVal
                  : null;

              if (paneObj?.authParams?.category_id && paneObj?.brands) {
                dispatch(
                  setPreWidgetsData(
                    graphObject1,
                    indexes,
                    panes[index]?.defaultFilters
                  )
                );
              }
            }
          });

          dispatch(
            setTicketOffset({
              widget_index: 6,
              id: "6",
            })
          );
        }
      });
  };
};

export const setSectionFilter = (sectionObj) => {
  const updatePanes = [...sectionObj?.panes];
  if (sectionObj?.duration?.from) {
    updatePanes[sectionObj?.index].sections[
      sectionObj?.section_index
    ].duration = sectionObj?.duration;
    updatePanes[sectionObj?.index].sections[
      sectionObj?.section_index
    ].dateFilters = [
      {
        attribute: "CreatedDate",
        type: "datetime",
        columns: {
          from: sectionObj?.duration?.from,
          to: sectionObj?.duration?.to,
        },
      },
    ];
  }

  updatePanes[sectionObj?.index].sections[sectionObj?.section_index].filters =
    sectionObj.filters;
  updatePanes[sectionObj?.index].sections[sectionObj?.section_index].is_locked =
    sectionObj.is_locked;

  return (dispatch) => {
    dispatch({ type: "SET_SECTION_FILTER", panes: updatePanes });
  };
};
export const setPaneOffset = (value, index, panes) => {
  const updatePanes = [...panes];
  if (updatePanes[index]) updatePanes[index].offset = value;
  return (dispatch) => {
    dispatch({ type: "SET_PANE_OFFSET", panes: updatePanes });
  };
};
export const setUpdateGraphType = (obj) => {
  const updatePanes = [...obj?.panes];

  updatePanes[obj?.index].sections[obj?.section_index].widgets[
    obj?.widget_index
  ].graphData.graph_type = obj?.value;
  updatePanes[obj?.index].sections[obj?.section_index].widgets[
    obj?.widget_index
  ].graph_type = obj?.value;

  return (dispatch) => {
    dispatch({ type: "SET_UPDATE_GRAPH_TYPE", panes: updatePanes });
  };
};

export const setIsPinned = (value, panes, index) => {
  const updatePanes = [...panes];
  if (updatePanes[index]) updatePanes[index].is_pinned = value;
  return (dispatch) => {
    dispatch({ type: "SET_IS_PINNED", panes: updatePanes });
  };
};

export const setIsAccessType = (value, panes, index) => {
  const updatePanes = [...panes];
  if (updatePanes[index]) updatePanes[index].access_type = value;
  return (dispatch) => {
    dispatch({ type: "SET_IS_ACCESS_TYPE", panes: updatePanes });
  };
};

export const setisDeepDive = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].isDeepDive = value;
  updatePanes[index].deep_dive = {
    infoBar: null,
    mentions: null,
    wordcloud: [],
    category: [],
    top_users: [],
    influencers: [],
    source_of_post: [],
    locations: [],
  };
  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_IS_DEEP_DIVE", panes: updatePanes });
  };
};
export const setIsDeepDiveDashboard = (value, paneIndex) => {
  return (dispatch) => {
    dispatch({
      type: "SET_IS_DEEP_DIVE_DASHBOARD",
      paneIndex: paneIndex,
      isDeepDiveDashboard: value,
    });
    if (value === false) {
      dispatch(resetDeepDiveDashboard());
    }
  };
};
export const setIsTicketTrandsView = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].isTicketTrandsView = value;
  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_IS_TICKET_TRANDS_VIEW", panes: updatePanes });
  };
};

export const clearPaginatedData = (panes, index, type) => {
  const updatePanes = [...panes];
  updatePanes[index].deep_dive = {
    ...updatePanes[index].deep_dive,
    [type]: {
      ...updatePanes[index].deep_dive?.[type],
      [`result`]: {
        ...updatePanes[index].deep_dive?.[type]?.result,
        data: null,
      },
    },
  };
  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_IS_DEEP_DIVE", panes: updatePanes });
  };
};

export const setDeepDiveData = (
  value,
  panes,
  index,
  widget_id,
  tabName,
  shareBrands,
  shareTemplateData
) => {
  const updatePanes = shareBrands ? { ...shareTemplateData } : [...panes];
  if (widget_id === "template-usage") {
    if (shareBrands) {
      updatePanes.deep_dive.template_usage_grid = value;
    } else {
      updatePanes[index].deep_dive.template_usage_grid = value;
    }
  } else if (widget_id === "ai-actionable") {
    if (shareBrands) {
      updatePanes.deep_dive.ai_actionable = value;
    } else updatePanes[index].deep_dive.ai_actionable = value;
  } else if (
    widget_id === "6.1" ||
    widget_id === "8.1" ||
    widget_id === "9.1"
  ) {
    //using same key 'ticket_chart' for work-flow-attr also
    if (shareBrands) {
      updatePanes.deep_dive.ticket_chart = value;
    } else updatePanes[index].deep_dive.ticket_chart = value;
  } else if (widget_id === "info-bar") {
    if (shareBrands) {
      updatePanes.deep_dive.infoBar = value;
    } else updatePanes[index].deep_dive.infoBar = value;
  } else if (tabName === "Mentions") {
    if (widget_id === "1.1") {
      if (shareBrands) {
        updatePanes.deep_dive.mentions = value;
      } else updatePanes[index].deep_dive.mentions = value;
    } else if (widget_id === "1.2") {
      if (shareBrands) {
        updatePanes.deep_dive.news_mentions = value;
      } else updatePanes[index].deep_dive.news_mentions = value;
    }
  } else if (tabName === "Word Cloud") {
    value.widget_id = widget_id;
    if (shareBrands) {
      updatePanes.deep_dive.wordcloud = setData(
        value,
        panes,
        index,
        "wordcloud",
        shareBrands,
        shareTemplateData
      );
    } else
      updatePanes[index].deep_dive.wordcloud = setData(
        value,
        panes,
        index,
        "wordcloud",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Category") {
    if (shareBrands) {
      updatePanes.deep_dive.category = setData(
        value,
        panes,
        index,
        "category",
        shareBrands,
        shareTemplateData
      );
    } else
      updatePanes[index].deep_dive.category = setData(
        value,
        panes,
        index,
        "category",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Top Users") {
    if (shareBrands) {
      updatePanes.deep_dive.top_users = setData(
        value,
        panes,
        index,
        "top_users",
        shareBrands,
        shareTemplateData
      );
    } else
      updatePanes[index].deep_dive.top_users = setData(
        value,
        panes,
        index,
        "top_users",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Influencers") {
    if (shareBrands) {
      updatePanes.deep_dive.influencers = setData(
        value,
        panes,
        index,
        "influencers",
        shareBrands,
        shareTemplateData
      );
    } else
      updatePanes[index].deep_dive.influencers = setData(
        value,
        panes,
        index,
        "influencers",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Source of Post") {
    if (shareBrands) {
      updatePanes.deep_dive.source_of_post = setData(
        value,
        panes,
        index,
        "source_of_post",
        shareBrands,
        shareTemplateData
      );
    } else
      updatePanes[index].deep_dive.source_of_post = setData(
        value,
        panes,
        index,
        "source_of_post",
        shareBrands,
        shareTemplateData
      );
  } else if (tabName === "Location Profiles") {
    if (shareBrands) {
      updatePanes.deep_dive.locations = setData(
        value,
        panes,
        index,
        "locations",
        shareBrands,
        shareTemplateData
      );
    } else
      updatePanes[index].deep_dive.locations = setData(
        value,
        panes,
        index,
        "locations",
        shareBrands,
        shareTemplateData
      );
  }
  if (!shareBrands) {
    global.panes = updatePanes;
  } else {
    updatePanes.isDeepDive = true;
  }

  return (dispatch) => {
    shareBrands
      ? dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updatePanes,
        })
      : dispatch({ type: "SET_IS_DEEP_DIVE", panes: updatePanes });
  };
};
export const setDeepDiveResponse = (value, panes, index) => {
  const updatePanes = [...panes];
  updatePanes[index].deepdive = {
    deepdiveResponse: [
      ...updatePanes[index].deepdive.deepdiveResponse,
      value?.response,
    ],
    tabName: value.tabName,
  };
  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_IS_DEEP_DIVE", panes: updatePanes });
  };
};
export const setData = (
  value,
  panes,
  index,
  tabName,
  shareBrands,
  shareTemplateData
) => {
  const updatePanes = shareBrands ? { ...shareTemplateData } : [...panes];
  let arr = shareBrands
    ? [...updatePanes?.deep_dive[tabName], value]
    : [...updatePanes[index].deep_dive[tabName], value];
  let sortedCloud = shareTemplateData?.deep_dive?.wordcloud
    ? shareTemplateData?.deep_dive?.wordcloud
    : panes[index]?.deep_dive?.wordcloud
    ? panes[index]?.deep_dive?.wordcloud
    : [];

  let sortedCategory = shareTemplateData?.deep_dive?.category
    ? shareTemplateData?.deep_dive?.category
    : panes[index]?.deep_dive?.category
    ? panes[index]?.deep_dive?.category
    : [];

  if (tabName === "wordcloud") {
    if (value?.widget_id === "2.1") {
      sortedCloud[0] = value;
    } else if (value?.widget_id === "2.2") {
      sortedCloud[1] = value;
    } else if (value?.widget_id === "2.3") {
      sortedCloud[2] = value;
    } else if (value?.widget_id === "2.4") {
      sortedCloud[3] = value;
    }
  }

  if (tabName === "category") {
    if (
      value?.result?.graph_name === "Category" ||
      value?.graph_name === "Category"
    ) {
      sortedCategory[0] = value;
    } else if (
      value?.result?.graph_name === "Sub Category" ||
      value?.graph_name === "Sub Category"
    ) {
      sortedCategory[1] = value;
    } else if (
      value?.result?.graph_name === "Sub Sub Category" ||
      value?.graph_name === "Sub Sub Category"
    ) {
      sortedCategory[2] = value;
    } else if (
      value?.result?.graph_name === "Upper Category" ||
      value?.graph_name === "Upper Category"
    ) {
      sortedCategory[3] = value;
    }
  }

  return tabName === "wordcloud"
    ? sortedCloud
    : tabName === "category"
    ? sortedCategory
    : arr;
};

export const FilterPillsDeepDiveResponse = (
  panes,
  index,
  authParams,
  finalObject,
  widget_ids,
  share_id
) => {
  const updatePanes = finalObject?.shareTemplateData
    ? { ...finalObject?.shareTemplateData }
    : [...panes];

  let data = finalObject?.shareTemplateData
    ? finalObject?.shareTemplateData.deep_dive["influencers"]?.filter(
        (el) => el?.result?.graph_type !== "post-card"
      )
    : updatePanes[index]?.deep_dive["influencers"]?.filter(
        (el) => el?.result?.graph_type !== "post-card"
      );

  if (finalObject?.shareTemplateData) {
    finalObject.shareTemplateData.deep_dive["influencers"] = data;
  } else {
    updatePanes[index].deep_dive["influencers"] = data;
  }

  global.panes = !finalObject?.shareTemplateData && updatePanes;
  return (dispatch) => {
    let loadingState = [];
    let arr = [1];
    arr?.forEach((e, i) => {
      dispatch(
        setDeepDiveWidgetLoaders({
          [`Influencers`]: [...loadingState, { [i]: true }],
        })
      );
      loadingState = [...loadingState, { [i]: true }];
    });
    !finalObject?.shareTemplateData &&
      dispatch({ type: "SET_IS_DEEP_DIVE", panes: updatePanes });
    dispatch(getDeepDive(authParams, finalObject, widget_ids, share_id, true));
  };
};

export const setCampaignDate = (value, panes, index) => {
  // const updatePanes = [...panes];
  // if (updatePanes[index]) updatePanes[index].campaign_date = value;
  // return (dispatch) => {
  //   dispatch({ type: "SET_CAMPAIGN_DATE", panes: updatePanes });
  // };

  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];

  if (updatePanes[index]) updatePanes[index].campaign_date = value;

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_CAMPAIGN_DATE", panes: updatePanes });
  };
};

export const setSimpleViewDuration = (value, panes, index) => {
  const updatePanes = [...panes];
  if (updatePanes[index]) updatePanes[index].simple_view_duration = value;
  return (dispatch) => {
    dispatch({ type: "SET_SIMPLE_VIEW_DURATION", panes: updatePanes });
  };
};

export const setActiveSectionId = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];

  if (updatePanes[index]) updatePanes[index].active_section_id = value;

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_ACTIVE_SECTION_ID", panes: updatePanes });
  };
};

export const setSelectedDeepdiveWidget = (
  section_index,
  widget_index,
  panes,
  index
) => {
  const updatePanes = [...panes];
  updatePanes[index].selected_deepdive_widget = {
    section_index: section_index,
    widget_index: widget_index,
  };
  return (dispatch) => {
    dispatch({ type: "SET_SELECTED_DEEPDIVE_WIDGET", panes: updatePanes });
  };
};

export const setDashboardTemplateFilters = (value, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  if (updatePanes[index]) updatePanes[index].dashboard_template_filters = value;

  global.panes = updatePanes;

  return (dispatch) => {
    dispatch({ type: "SET_DASHBOARD_TEMPLATE_FILTERS", panes: updatePanes });
  };
};

export const setDashboardCalledApiList = (
  value,
  panes,
  index,
  resetDashboardEditedFlag = false
) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];

  if (updatePanes[index]) updatePanes[index].dashboard_called_api_list = value;
  if (resetDashboardEditedFlag) {
    updatePanes[index].is_dashboard_edited = false;
  }

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_DASHBOARD_CALLED_API_LIST", panes: updatePanes });
  };
};

export const updateDashboardWidgetProfileFilters = (
  panes,
  index,
  section_index,
  widget_index
) => {
  const updatePanes = [...panes];

  if (updatePanes?.[index]?.sections) {
    updatePanes[index].sections[section_index].widgets[
      widget_index
    ].profile_filters = null;
    updatePanes[index].sections[section_index].widgets[
      widget_index
    ].is_locked = false;
  } else {
    updatePanes[index].section[0].widgets[widget_index].profile_filters = null;
    updatePanes[index].section[0].widgets[widget_index].is_locked = false;
  }

  return (dispatch) => {
    dispatch({
      type: "SET_DASHBOARD_WIDGET_PROFILE_FILTERS",
      panes: updatePanes,
    });
  };
};

export const setDashboardWidgetProfileFilters = (
  panes,
  index,
  section_index,
  widget_index,
  value
) => {
  const updatePanes = [...panes];

  if (updatePanes?.[index]?.sections) {
    updatePanes[index].sections[section_index].widgets[
      widget_index
    ].profile_filters = value;
  } else {
    updatePanes[index].section[0].widgets[widget_index].profile_filters = value;
  }

  return (dispatch) => {
    dispatch({
      type: "SET_DASHBOARD_WIDGET_PROFILE_FILTERS",
      panes: updatePanes,
    });
  };
};
export const setPrivateConversation = (value, panes, index, filters) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].private_conversation = value;
  if (filters) {
    updatePanes[index].filters = filters;
  }
  return (dispatch) => {
    dispatch({
      type: "SET_DASHBOARD_PRIVATE_CONVERSATION",
      panes: updatePanes,
    });
  };
};
export const setPublicEngagementConversation = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].public_engagement_only = value;
  return (dispatch) => {
    dispatch({
      type: "SET_DASHBOARD_PUBLIC_ENGAGEMENT_CONVERSATION",
      panes: updatePanes,
    });
  };
};
export const setTicketIsModifiedDate = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].is_modified_date = value;

  return (dispatch) => {
    dispatch({ type: "SET_TICKET_IS_MODIFIED_DATE", panes: updatePanes });
  };
};

export const setGlobalProfileFilterList = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].profile_filters_list = value;

  return (dispatch) => {
    dispatch({ type: "SET_GLOBAL_PROFILE_FILTERS_LIST", panes: updatePanes });
  };
};

export const setUpdateDeepDive = (
  value,
  panes,
  index,
  keyName,
  widget_data_index
) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  if (keyName === "wordcloud") {
    updatePanes[index].deep_dive.wordcloud[widget_data_index] = value;
  } else if (keyName === "category") {
    updatePanes[index].deep_dive.category[widget_data_index] = value;
  } else if (keyName === "source_of_post") {
    updatePanes[index].deep_dive.source_of_post[widget_data_index] = value;
  } else if (keyName === "influencers") {
    updatePanes[index].deep_dive.influencers[widget_data_index] = value;
  } else {
    updatePanes[index].deep_dive[keyName] = value;
  }
  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_IS_DEEP_DIVE", panes: updatePanes });
  };
};

export const setTemplateFiltersInPane = (templateDetails, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].filter_template_details = {
    filter_templates: templateDetails.filter_templates
      ? [...templateDetails.filter_templates]
      : [],
    pinned_filter_templates: templateDetails.pinned_filter_templates
      ? [...templateDetails.pinned_filter_templates]
      : [],
  };
  return (dispatch) => {
    dispatch({ type: "SET_QUICK_FILTER_TEMPLATE", panes: updatePanes });
  };
};
export const setTemplateFiltersInShareTemplate = (templateDetails) => {
  return {
    type: "SET_QUICK_FILTERS_IN_SHARE_TEMPLATE_DATA",
    filter_templates: templateDetails?.filter_templates || [],
    pinned_filter_templates: templateDetails?.pinned_filter_templates || [],
  };
};

export const setSelectedPillInPane = (templateDetails, index, panes) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  let tempPaneFilters = updatePanes[index].filters;
  let selectedPill =
    updatePanes[index]?.selected_pills?.[0]?.saved_filters?.length;
  if (
    updatePanes[index]?.template_type === "competition" &&
    !updatePanes[index]?.private_conversation
  ) {
    let saved = templateDetails?.saved_filters;
    let comp_hidden_filters = updatePanes[index]?.comp_hidden_filter;

    if (!Object.keys(templateDetails).length) {
      if (tempPaneFilters?.length) {
        if (selectedPill) {
          let pillFilter =
            updatePanes[index]?.selected_pills?.[0]?.saved_filters;
          tempPaneFilters = removeHiddenFromSaved(
            deepCopy(tempPaneFilters),
            deepCopy(pillFilter)
          );
        }
        tempPaneFilters = mergeArrays(
          deepCopy(comp_hidden_filters),
          deepCopy(tempPaneFilters)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          deepCopy(comp_hidden_filters),
          deepCopy(tempPaneFilters)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filter applied, please recheck the filters",
            "info"
          );
        }
      } else {
        tempPaneFilters = [...deepCopy(comp_hidden_filters)];
      }
    } else {
      if (tempPaneFilters.length && selectedPill) {
        let selectedPillFilter =
          updatePanes[index]?.selected_pills[0]?.saved_filters;
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(comp_hidden_filters)
        );
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(selectedPillFilter)
        );
        tempPaneFilters = mergeArrays(
          deepCopy(tempPaneFilters),
          deepCopy(saved)
        );
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        tempPaneFilters = mergeArrays(
          tempPaneFiltersCopy,
          deepCopy(comp_hidden_filters)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          deepCopy(comp_hidden_filters)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filters applied, please check your filters",
            "info"
          );
        }
      } else if (tempPaneFilters?.length) {
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        tempPaneFilters = mergeArrays(tempPaneFiltersCopy, deepCopy(saved));
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          deepCopy(saved)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filters applied, please check your filters",
            "info"
          );
        }
      } else {
        let saved_filters_copy = saved?.length ? deepCopy(saved) : [];

        tempPaneFilters = mergeArrays(
          deepCopy(comp_hidden_filters),
          deepCopy(saved_filters_copy)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          deepCopy(comp_hidden_filters),
          deepCopy(saved_filters_copy)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filters applied, please check your filters",
            "info"
          );
        }
      }
    }

    updatePanes[index].filters = tempPaneFilters;
    updatePanes[index].selected_pills = templateDetails
      ? [templateDetails]
      : [];
  } else {
    if (Object.keys(templateDetails)?.length > 0) {
      let saved_filters = templateDetails?.saved_filters;
      if (tempPaneFilters?.length && selectedPill) {
        let pillFilter = updatePanes[index]?.selected_pills?.[0]?.saved_filters;
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(pillFilter)
        );
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        tempPaneFilters = mergeArrays(
          tempPaneFiltersCopy,
          deepCopy(saved_filters)
        );
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          deepCopy(saved_filters)
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filter applied, please recheck the filters",
            "info"
          );
        }
      } else if (tempPaneFilters?.length) {
        let tempPaneFiltersCopy = deepCopy(tempPaneFilters);
        let saved_filtersCopy = deepCopy(saved_filters);
        tempPaneFilters = mergeArrays(tempPaneFiltersCopy, saved_filtersCopy);
        let isFilterConflict = isSameFilterDiffTypes(
          tempPaneFiltersCopy,
          saved_filtersCopy
        );
        if (isFilterConflict) {
          callNotification(
            "Conflicting filter applied, please recheck the filters",
            "info"
          );
        }
      } else {
        tempPaneFilters = [...deepCopy(saved_filters)];
      }
    } else {
      if (selectedPill) {
        let pillFilter = updatePanes[index]?.selected_pills?.[0]?.saved_filters;
        tempPaneFilters = removeHiddenFromSaved(
          deepCopy(tempPaneFilters),
          deepCopy(pillFilter)
        );
      }
      tempPaneFilters = tempPaneFilters?.length ? tempPaneFilters : [];
    }
    if (updatePanes[index]?.hidden_filter) {
      let hiddenAttribute =
        updatePanes[index]?.hidden_filter?.attribute?.toLowerCase();
      tempPaneFilters = deepCopy(tempPaneFilters)?.filter(
        (item) => item?.attribute?.toLowerCase() !== hiddenAttribute
      );
      if (Object.keys(templateDetails)?.length > 0) {
        let channelIndexInSelectedPill =
          templateDetails?.saved_filters.findIndex(
            (item) => item?.attribute?.toLowerCase() === "socialmediaplatforms"
          );
        if (channelIndexInSelectedPill > -1) {
          callNotification(
            "Conflicting filters applied, please recheck the filters",
            "info"
          );
        }
      }
    }
    updatePanes[index].filters = tempPaneFilters;
    updatePanes[index].selected_pills = templateDetails
      ? [templateDetails]
      : [];
  }
  return (dispatch) => {
    dispatch({ type: "SET_QUICK_FILTER_TEMPLATE", panes: updatePanes });
  };
};

export const setIsWidgetMakerOpenObj = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].is_widget_maker_open_obj = value;

  return (dispatch) => {
    dispatch({ type: "SET_IS_WIDGET_MAKER_OPEN_OBJ", panes: updatePanes });
  };
};

export const setEditedWidgetGraphConfig = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  updatePanes[index].edited_widgetGraphConfig = value;

  return (dispatch) => {
    dispatch({ type: "SET_EDITED_WIDGET_GRAPH_CONFIG", panes: updatePanes });
  };
};

export const setIsProlificUserDeepDive = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  if (updatePanes[index]) updatePanes[index].is_prolific_user_deep_dive = value;

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_IS_PROLIFIC_USER_DEEP_DIVE", panes: updatePanes });
  };
};

// update widget changes in pane
export const setSaveWidgetChanges = (value, panes, index) => {
  let global_panes = global?.panes ? global?.panes : panes;
  const updatePanes = global?.panes ? [...global_panes] : [...panes];
  if (updatePanes[index]) updatePanes[index].save_widget_changes = value;

  global.panes = updatePanes;
  return (dispatch) => {
    dispatch({ type: "SET_SAVE_WIDGET_CHANGES", panes: updatePanes });
  };
};
